const validationRules = {
  validators: {
    privateKeyPartnerValidator(v) {
      if (!v) return true;
      const pemFormat = /^-----BEGIN ([A-Z ]+)-----[\s\S]+-----END \1-----$/;
      return pemFormat.test(v.trim());
    },
    
    endpointURLValidator(v) {
      if (!v) return true;
      const urlPattern = /^(https?:\/\/)[^\s$.?#].[^\s]*$/i;
      return urlPattern.test(v.trim());
    },
    
    callbackPartnerUrlTokenValidator(v) {
      if (!v) return true;
      const urlPattern = /^(https?:\/\/)[^\s$.?#].[^\s]*$/i;
      return urlPattern.test(v.trim());
    }
  }
  
};

export default validationRules;